import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorHandler } from '../../helper/error_handler';
import { isErrorWithMessage } from '../../helper';
import { resettingWaterCoolerLoader } from '../slices/watercooler';
import { RootState } from '../../redux/store';
import WaterCoolerApi from '../../apis/watercooler';

export const fetchWaterCoolerThunk = createAsyncThunk(
    'watercooler/fetch',
    async (client_id: number, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await WaterCoolerApi.fetchWaterCooler(state.app.token, client_id);
            if (response?.success === 1) {
                return {
                    waterCooler: response?.waterCooler,
                    conversations: response?.conversations
                };
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingWaterCoolerLoader());
        }
    }
);

export const createWaterCoolerConversationThunk = createAsyncThunk(
    'watercooler/create-conversation',
    async (data: { message: string, file: string, client_id: number }, { dispatch, rejectWithValue, getState }): Promise<unknown> => {
        try {
            const state = getState() as RootState;
            const response = await WaterCoolerApi.createWaterCoolerConversation(
                state.app.token,
                state.watercooler.selectedWaterCooler?.id || 0,
                data.message,
                data.file
            );
            if (response?.success === 1) {
                await dispatch(fetchWaterCoolerThunk(data.client_id)).unwrap();
                return response?.true;
            }
            return errorHandler(response?.msg as string || 'Request failed', dispatch, rejectWithValue);
        } catch (error) {
            if (isErrorWithMessage(error)) {
                return errorHandler(error.message, dispatch, rejectWithValue);
            }
            return errorHandler('An unknown error occurred', dispatch, rejectWithValue);
        } finally {
            dispatch(resettingWaterCoolerLoader());
        }
    }
);